// extracted by mini-css-extract-plugin
export var searchHeader = "_6r-0";
export var searchHeaderDark = "_6r-1";